const state = {
  name: '',
  avatar: '',
  account: '',
  phone: '',
  email: '',
  userId: '',
  userName: '',
  birthday: '',
  deptId: '',
  deptName: '',
  loaded: false,
  info: null,
  admin: false,
  publisher: false,
  userType:'',
  supplierInfo:{}
}

const mutations = {
  SET_INFO: (state, user) => {
    const keys = Object.keys(state)
    let i = 0
    for (i; i < keys.length; i++) {
      if (user.hasOwnProperty(keys[i])) {
        state[keys[i]] = user[keys[i]]
      }
    }
    state.loaded = true
  },
  CLEAR_INFO: state => {
    state.loaded = false;
    state.info = null;
    state.name = '';
    state.avatar = '';
    state.account = '';
    state.phone = '';
    state.email = '';
    state.userId = '';
    state.userName = '';
    state.birthday = '';
    state.supplierInfo = {};
  }
}

const actions = {
  setInfo({commit}, user) {
    return new Promise(resolve => {
      commit('SET_INFO', user)
      resolve()
    })
  },

  clearInfo({commit}) {
    return new Promise(resolve => {
      commit('CLEAR_INFO')
      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
